import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const SuccessActivatedModalUi = () => {
  return (
    <>
      <div className={styles.header}>
        <Icon fontSize={32} icon={'check2'} color={'var(--green-60)'} />
        <div className={styles.info}>
          <Typography ariaLabel={'Agent activated'} variant={'heading-lg'}>
            Agent activated
          </Typography>
          <Typography
            ariaLabel={'Agent activated'}
            variant={'body-rg-regular'}
            color={'var(--content-primary-secondary)'}
            className={styles.center}
          >
            To start answering calls with your agent, assign <br />
            it to one or more inboxes
          </Typography>
        </div>
      </div>
      <div className={styles.list}>
        <div className={styles.card}>
          <Typography ariaLabel={'number'} className={styles.number} variant={'body-sm-medium'}>
            1
          </Typography>
          <Typography ariaLabel={'title'} variant={'body-md-regular'}>
            Go to inbox calling settings
          </Typography>
        </div>
        <div className={styles.card}>
          <Typography ariaLabel={'number'} className={styles.number} variant={'body-sm-medium'}>
            2
          </Typography>
          <Typography ariaLabel={'title'} variant={'body-md-regular'}>
            Turn on AI Calling Agent and assign this agent
          </Typography>
        </div>
      </div>
    </>
  )
}
